<div class="message-bar-content" [class.no-messages]="!hasMessages">
  <div class="no-message-placeholder" *ngIf="!hasMessages"></div>

  <app-message *ngIf="messageToBeShown" [message]="messageToBeShown"></app-message>
</div>
